// import React from 'react';
// import { Link } from "react-router-dom";
// import './Footer.css';

// const Footer = () => {
//   return (
//     <footer className="app-footer">
//       <div className="app-footer__content">
//         <div className="app-footer__column app-footer__about">
//           <h3 className="app-footer__heading">About Us</h3>
//           <p className="app-footer__text">
//             Welcome to our Family! We are leaders in delivering top-notch services and cutting-edge solutions tailored to your needs. 
//             Our team is fueled by a passion for innovation and a relentless pursuit of excellence. 
//             We believe in building lasting relationships with our clients, driven by trust, transparency, and a shared vision for success. 
//             <strong style={{color:'#fbb475'}}><br /><br />EZHUMIN™ </strong> is a brand owned and operated by Vetrieq.
//           </p>
//         </div>
//         <div className="app-footer__column app-footer__contact">
//           <h3 className="app-footer__heading">Contact Us</h3>
//           <p className="app-footer__text">
//             We’re here to assist you! Reach out to us via any of the following methods:
//             <br />Email: <strong style={{color:'#fbb577'}}>info@vetrieq.com</strong>
//             <br />Phone: <strong style={{color:'#fbb475'}}>(+91) 9555264537</strong> 
//             <br />Address: Villivakkam, Chennai, Tamilnadu, India - 600049
//           </p>
//         </div>
//         <div className="app-footer__column app-footer__social">
//           <h3 className="app-footer__heading">Follow Us</h3>
//           <p className="app-footer__text">Stay connected with us :</p>
//           <ul className="app-footer__social-list">
//             <li className="app-footer__social-item"><a href="https://www.linkedin.com/in/rathinakumar-sundarajan-26610b20b/" target="_blank" rel="noopener noreferrer" className="app-footer__social-link">LinkedIn</a></li>
//             <li className="app-footer__social-item"><a href="https://x.com/Vetrieq_global" target="_blank" rel="noopener noreferrer" className="app-footer__social-link">Twitter</a></li>
//             <li className="app-footer__social-item"><a href="https://www.instagram.com/Vetrieq.global?igsh=YXI0eGRubzd2MHps" target="_blank" rel="noopener noreferrer" className="app-footer__social-link">Instagram</a></li>
//             <li className="app-footer__social-item"><a href="https://www.facebook.com/share/1BuyBXjSDe/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="app-footer__social-link">Facebook</a></li>
//             <li className="app-footer__social-item"><a href="https://www.youtube.com/@rathinakumarsundarajan1192" target="_blank" rel="noopener noreferrer" className="app-footer__social-link">YouTube</a></li>
//           </ul>
//         </div>
//         <div className="app-footer__column app-footer__links">
//           <h3 className="app-footer__heading">Quick Links</h3>
//           <p className="app-footer__text"></p>
//           <ul className="app-footer__links-list">
// <li className="app-footer__links-item">
//   <Link to="/" className="app-footer__links-link">Home</Link>
// </li>
// <li className="app-footer__links-item">
//   <Link to="/about" className="app-footer__links-link">About</Link>
// </li>
// <li className="app-footer__links-item">
//   <Link to="/products" className="app-footer__links-link">Products</Link>
// </li>
// <li className="app-footer__links-item">
//   <Link to="/contactus" className="app-footer__links-link">Contact</Link>
// </li>
// <li className="app-footer__links-item">
//   <Link to="/about" className="app-footer__links-link">Blog</Link>
// </li>
            
//           </ul>
//         </div>
//       </div>
//       <div className="app-footer__bottom">
//         <p className="app-footer__text">&copy; 2024 Your Company. All rights reserved. | <Link to="/">Privacy Policy</Link> | <Link to ="/">Terms of Service</Link></p>
//       </div>
//     </footer>
//   );
// };

// export default Footer;



// Footer.jsx

import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">

      {/* TOP SECTION */}
      <div className="footer-top">

        {/* BRAND INFO */}
        <div className="footer-column footer-brand">

          <h2 className="footer-logo">
            Vetrieq <span>Global Exports</span>
          </h2>

          <p className="footer-description">
            Delivering premium Indian products worldwide with trust,
            quality, and excellence. We specialize in global exports,
            eco_friendly products, spices, food ingredients, handicrafts,
            and traditional Indian goods.
          </p>

          <div className="footer-badge">
            EZHUMIN™ is a brand owned and operated by Vetrieq.
          </div>

        </div>

        {/* QUICK LINKS */}
        {/* <div className="footer-column">

          <h3 className="footer-heading">Quick Links</h3>

          <ul className="footer-links">

            <li>
              <Link to="/">Home</Link>
            </li>

            <li>
              <Link to="/about">About</Link>
            </li>

            <li>
              <Link to="/products">Products</Link>
            </li>

            <li>
              <Link to="/contactus">Contact</Link>
            </li>

            <li>
              <Link to="/blog">Blog</Link>
            </li>

          </ul>

        </div> */}

        {/* CONTACT INFO */}
        <div className="footer-column">

          <h3 className="footer-heading">Contact Info</h3>

          <div className="footer-contact">

            <p>
              📧 info@vetrieq.com
            </p>

            <p>
              📞 (+91) 9555264537
            </p>

            <p>
              📍 Villivakkam, Chennai,
              Tamil Nadu, India - 600049
            </p>

          </div>

        </div>

        {/* SOCIAL */}
        <div className="footer-column">

          <h3 className="footer-heading">Follow Us</h3>

          <div className="social-links">

            <a
              href="https://www.linkedin.com/in/rathinakumar-sundarajan-26610b20b/"
              target="_blank"
              rel="noopener noreferrer"
            >
              LinkedIn
            </a>

            <a
              href="https://x.com/Vetrieq_global"
              target="_blank"
              rel="noopener noreferrer"
            >
              Twitter
            </a>

            <a
              href="https://www.instagram.com/Vetrieq.global?igsh=YXI0eGRubzd2MHps"
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </a>

            <a
              href="https://www.facebook.com/share/1BuyBXjSDe/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
            >
              Facebook
            </a>

            <a
              href="https://www.youtube.com/@rathinakumarsundarajan1192"
              target="_blank"
              rel="noopener noreferrer"
            >
              YouTube
            </a>

          </div>

        </div>

      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">

        <p>
          © 2025 Vetrieq Global Exports. All rights reserved.
        </p>

        <div className="footer-bottom-links">

          <Link to="/">Privacy Policy</Link>

          <span>|</span>

          <Link to="/">Terms & Conditions</Link>

        </div>

      </div>

    </footer>
  );
};

export default Footer;